import { boolean, object } from "superstruct";

const RewardsStorefrontValuesRewardPageAvailabilitySchema = object({
    canUseRewardPage: boolean(),
});

export default RewardsStorefrontValuesRewardPageAvailabilitySchema;
